export const err = {
  NETWORK: 'Network error - make sure API is running',
  SERVER: 'Server error - check the terminal for more info',
  UNAUTHORIZED: 'Authorization Required',
  NOTFOUND: '404 not found',
  DEFAULT: 'Something went wrong',
  LARGE_REQ: 'File can not be larger than 8mb',
};
